import React from 'react';
import { Link } from 'react-router-dom';

/**
 * SideNav Component
 * 
 * Exactly matches the legacy site's sidebar structure.
 * Updated to reflect the correct URL structure in the React app.
 */
const SideNav = () => {
  return (
    <div>
      <ol className="sidenav-tk">
        <div className="sidenav-title-tk"><Link to="/">R&D Toolkit</Link></div>
        
        <div className="dropdown">
          <li className="link-tk"><Link to="/">Overview</Link></li>
          <div className="dropdown-content">
            <ol className="sidebar-list">
              <div className="menu-title">Overview</div>
              
              <div className="dropdown-sub">
                <Link to="/#introduction"><li>Introduction</li></Link>
                <div className="dropdown-content-sub">
                  <ol>
                    <Link to="/#recent-updates"><li>Recent Updates</li></Link>
                  </ol>
                </div>
              </div>
              
              <div className="dropdown-sub">
                <Link to="#"><li>Tools</li></Link>
                <div className="dropdown-content-sub">
                  <ol>
                    <Link to="/research/"><li>Research</li></Link>
                    <Link to="/design/"><li>Design</li></Link>
                    <Link to="/delivery/"><li>Delivery</li></Link>
                  </ol>
                </div>
              </div>
              
              <div className="dropdown-sub">
                <Link to="/resources/"><li>Resources</li></Link>
                <div className="dropdown-content-sub">
                  <ol>
                    <Link to="/resources/#R&D"><li>R&D</li></Link>
                    <Link to="/resources/#websites"><li>Websites</li></Link>
                    <Link to="/resources/#project-tracking"><li>Project Tracking</li></Link>
                    <Link to="/resources/#further-resources"><li>Further Resources</li></Link>
                  </ol>
                </div>
              </div>
            </ol>
          </div>
        </div>
        
        <div className="dropdown">
          <li className="link-tk"><Link to="/research/">Research</Link></li>
          <div className="dropdown-content">
            <ol className="sidebar-list">
              <div className="menu-title">Research Tools</div>
              
              <div className="dropdown-sub">
                <Link to="/research#problem"><li>Problem</li></Link>
                <div className="dropdown-content-sub">
                  <ol>
                    <Link to="/research/problem/discovery/"><li>Discovery</li></Link>
                    <Link to="/research/problem/prioritisation/"><li>Prioritisation</li></Link>
                    <Link to="/research/problem/project-scoping/"><li>Project Scoping</li></Link>
                    <Link to="/research/problem/framing/"><li>Framing</li></Link>
                  </ol>
                </div>
              </div>
              
              <div className="dropdown-sub">
                <Link to="/research#empathise"><li>Empathise</li></Link>
                <div className="dropdown-content-sub">
                  <ol>
                    <Link to="/research/empathise/investigate/"><li>Investigate</li></Link>
                    <Link to="/research/empathise/user-interview/"><li>User Interview</li></Link>
                    <Link to="/research/empathise/user-insights/"><li>User Insights</li></Link>
                    <Link to="/research/empathise/data/"><li>Data</li></Link>
                  </ol>
                </div>
              </div>
              
              <div className="dropdown-sub">
                <Link to="/research#mapping"><li>Mapping</li></Link>
                <div className="dropdown-content-sub">
                  <ol>
                    <Link to="/research/mapping/research-mapping/"><li>Research Mapping</li></Link>
                    <Link to="/research/mapping/user-mapping/"><li>User Mapping</li></Link>
                    <Link to="/research/mapping/organisation-mapping/"><li>Organisation Mapping</li></Link>
                  </ol>
                </div>
              </div>
              
              <div className="dropdown-sub">
                <Link to="/research#synthesis"><li>Synthesis</li></Link>
                <div className="dropdown-content-sub">
                  <ol>
                    <Link to="/research/synthesis/problem-reframing/"><li>Problem Reframing</li></Link>
                    <Link to="/research/synthesis/define/"><li>Define</li></Link>
                    <Link to="/research/synthesis/feature-prioritisation/"><li>Feature Prioritisation</li></Link>
                  </ol>
                </div>
              </div>
            </ol>
          </div>
        </div>
        
        <div className="dropdown">
          <li className="link-tk"><Link to="/design/">Design</Link></li>
          <div className="dropdown-content">
            <ol className="sidebar-list">
              <div className="menu-title">Design Tools</div>
              
              <div className="dropdown-sub">
                <Link to="/design#ideation"><li>Ideation</li></Link>
                <div className="dropdown-content-sub">
                  <ol>
                    <Link to="/design/ideation/warm-up/"><li>Warm Up</li></Link>
                    <Link to="/design/ideation/sketching/"><li>Sketching</li></Link>
                    <Link to="/design/ideation/storyboarding/"><li>Storyboarding</li></Link>
                    <Link to="/design/ideation/design-studio/"><li>Design Studio</li></Link>
                  </ol>
                </div>
              </div>
            </ol>
          </div>
        </div>
        
        <div className="dropdown">
          <li className="link-tk"><Link to="/delivery/">Delivery</Link></li>
          <div className="dropdown-content">
            <ol className="sidebar-list">
              <div className="menu-title">Delivery Tools</div>
              
              <div className="dropdown-sub">
                <Link to="/delivery/agile/"><li>Agile</li></Link>
              </div>
              
              <div className="dropdown-sub">
                <Link to="/delivery/scrum/"><li>Scrum</li></Link>
              </div>
            </ol>
          </div>
        </div>
      </ol>
    </div>
  );
};

export default SideNav; 